import type { Affiliate, Program } from '@fluenceur/types';
import api from '@/libs/axiosInstance';

export const updateProgram = async (id: string, payload: any): Promise<Program> => {
  const response = await api.put<Program>(`/dashboard/programs/${id}`, payload);
  return response.data;
};

export interface AffiliateResponse {
  affiliates: Affiliate[];
}
